import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    tenantId: Number,
    companyId: String,
    software: String
  }

  connect() {
    this.initializeDropdownListeners()
  }

  initializeDropdownListeners() {
    // Add event listeners for lookup filter dropdown selections
    const lookupFilterDropdowns = this.element.querySelectorAll('[data-lookup-filter]')

    lookupFilterDropdowns.forEach(dropdown => {
      const selectButtons = dropdown.querySelectorAll('[data-action*="click->dropdown#select"]')
      selectButtons.forEach(button => {
        button.addEventListener('click', this.onLookupFilterSelect.bind(this))
      })

      const clearButtons = dropdown.querySelectorAll('[data-action*="click->dropdown#clear"]')
      clearButtons.forEach(button => {
        button.addEventListener('click', this.onLookupFilterClear.bind(this))
      })
    })
  }

  onLookupFilterSelect(event) {
    const value = event.currentTarget.dataset.value
    const dropdown = event.currentTarget.closest('[data-lookup-filter]')
    const lookupType = dropdown.dataset.lookupFilter
    const paramName = `lookup_filter_${lookupType}`

    // Update the hidden input for this lookup filter
    this.updateHiddenInput(paramName, value)

    // Submit the form to apply the filter
    this.submitFilterForm()

    event.preventDefault()
  }

  onLookupFilterClear(event) {
    const dropdown = event.currentTarget.closest('[data-lookup-filter]')
    const lookupType = dropdown.dataset.lookupFilter
    const paramName = `lookup_filter_${lookupType}`

    // Clear the hidden input for this lookup filter
    this.updateHiddenInput(paramName, '')

    // Submit the form to remove the filter
    this.submitFilterForm()

    event.preventDefault()
  }

  updateHiddenInput(name, value) {
    const form = this.element.closest('form')
    let hiddenInput = form.querySelector(`input[name="${name}"]`)

    if (!hiddenInput && value) {
      // Create hidden input if it doesn't exist and we have a value
      hiddenInput = document.createElement('input')
      hiddenInput.type = 'hidden'
      hiddenInput.name = name
      form.appendChild(hiddenInput)
    }

    if (hiddenInput) {
      if (value) {
        hiddenInput.value = value
      } else {
        // Remove the input if value is empty
        hiddenInput.remove()
      }
    }
  }

  submitFilterForm() {
    const form = this.element.closest('form')
    if (form) {
      form.submit()
    }
  }
}
